/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import type { Pecoto } from './Pecoto';

export enum ListeTrimestre {
  premierTrimestre = '1er trimestre',
  deuxiemeTrimestre = '2ème trimestre',
  troisiemeTrimestre = '3ème trimestre',
  quatriemeTrimestre = '4ème trimestre',
}

export type Trimestre = {
  identifiant: number;
  identifiantEntite: number;
  identifiantPecoto: number;
  periode: number;
  annee: number;
  dateNumerotation: Date;
  dateCloture: Date;
  dateEdition: Date;
  pecoto?: Pecoto;
};
